// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__27MBA","right":"styles_right__UH-2W"};